import {
  SERVICE_HOLDER_USER_STATUS_ACTIVE,
  SERVICE_HOLDER_USER_STATUS_ADMISSION_TO_RESIDENCE,
  SERVICE_HOLDER_USER_STATUS_DEATH,
  SERVICE_HOLDER_USER_STATUS_HOSPITALIZATION,
  SERVICE_HOLDER_USER_STATUS_INACTIVE,
} from "./types";

const status = [
  {
    value: SERVICE_HOLDER_USER_STATUS_ACTIVE,
  },
  {
    value: SERVICE_HOLDER_USER_STATUS_ADMISSION_TO_RESIDENCE,
  },
  {
    value: SERVICE_HOLDER_USER_STATUS_DEATH,
  },
  {
    value: SERVICE_HOLDER_USER_STATUS_HOSPITALIZATION,
  },
  {
    value: SERVICE_HOLDER_USER_STATUS_INACTIVE,
  },
];

export function serviceHolderUserStatusList() {
  return status;
}
